import { Contact } from '@features/contacts/types/contact'

import { Paging } from '../../../types/metable'
import { useContactsListFilters } from './useContactsListFilters'
import { useFetchContacts } from './useFetchContacts'

interface UseContactsProps {
  isCustomer?: boolean
  isSupplier?: boolean
}

interface UseContactsResponse {
  contacts: Contact[]
  isLoading: boolean
  pagination?: Paging
}

export const useContacts = ({ isCustomer, isSupplier }: UseContactsProps): UseContactsResponse => {
  const [queryProps] = useContactsListFilters()
  const { contacts, isLoading, pagination } = useFetchContacts({ ...queryProps, isCustomer, isSupplier })

  return {
    contacts,
    isLoading,
    pagination,
  }
}
